<input
    #inputElement
    type="text"
    inputmode="decimal"
    class="focus-none grow-[1] shrink-0 basis-0 min-w-0 m-0 py-0 border-0 bg-transparent text-inherit [text-align:inherit] disabled:placeholder:text-transparent"
    [attr.id]="inputId()"
    [readonly]="readonly()"
    [disabled]="disabled()"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-describedby]="errorMessageId()"
    [attr.placeholder]="placeholder()"
    (input)="onInput()"
    (blur)="onBlur()"
/>

@if (unit()) {
    <span
        class="unit ms-2 pe-[var(--si-feedback-icon-offset,0)]"
        [class.text-secondary]="!disabled()"
        [class.text-disabled]="disabled()"
    >
        {{ unit() }}
    </span>
} @else {
    <span class="unit pe-[var(--si-feedback-icon-offset,0)]"></span>
}

@if (showButtons()) {
    <button
        type="button"
        tabindex="-1"
        aria-hidden="true"
        class="dec btn btn-circle btn-tertiary my-n3 ms-2 btn-sm"
        [disabled]="disabled() || readonly() || !canDecrease()"
        (mousedown)="startAutoRepeat($event, false)"
        (touchstart)="startAutoRepeat($event, false)"
        (mouseup)="stopAutoRepeat()"
        (mouseleave)="stopAutoRepeat()"
        (touchend)="stopAutoRepeat()"
    >
        <i class="icon element-minus"></i>
    </button>
    <button
        type="button"
        tabindex="-1"
        aria-hidden="true"
        class="inc btn btn-circle btn-tertiary my-n3 me-n2 btn-sm"
        [disabled]="disabled() || readonly() || !canIncrease()"
        (mousedown)="startAutoRepeat($event, true)"
        (touchstart)="startAutoRepeat($event, true)"
        (mouseup)="stopAutoRepeat()"
        (mouseleave)="stopAutoRepeat()"
        (touchend)="stopAutoRepeat()"
    >
        <i class="icon element-plus"></i>
    </button>
}
